import React from 'react';
import { useTranslation } from 'react-i18next';
import { JobPriority } from '../../types/job';
import { InputGroup } from '../common/InputGroup';
import { ListingOptions } from './ListingOptions';
import { DropdownSelect } from '../common/DropdownSelect';

interface PrioritySelectorProps {
  priorities: JobPriority[];
  selectedPriority?: JobPriority | null;
  setSelectedPriority?: (priority: JobPriority | null) => void;
  error?: string;
  clearError?: () => void;
}

const PrioritySelector: React.FC<PrioritySelectorProps> = ({
  priorities,
  selectedPriority,
  setSelectedPriority,
  error,
  clearError,
}) => {
  const { t } = useTranslation(['jobs']);

  return (
    <div className="flex flex-col md:flex-row gap-8">
      <div className="flex-1 mr-4">
        <InputGroup label="" error={!!error} errorMessage={error}>
          <DropdownSelect<JobPriority>
            value={selectedPriority}
            onChange={(_val: string, item?: JobPriority) => {
              if (setSelectedPriority) {
                setSelectedPriority(item || null);
              }
              if (error && clearError) clearError();
            }}
            options={priorities}
            getOptionLabel={item => item.details}
            getOptionValue={item => item.id}
            placeholder={t('publish.priorities.standard.details', { count: 1 })}
            showDropdownIcon={true}
            error={!!error}
          />
        </InputGroup>
        <p className="mt-2 text-sm text-secondary">{t('publish.priority_help')}</p>
      </div>

      <div className="flex-1 ml-4">
        <ListingOptions priorities={priorities} />
      </div>
    </div>
  );
};

export default PrioritySelector;
